import IContest from '../models/IContest'
import IOrder from '../models/IOrder'

export default class Api {
  public async getContest(contestSlug: string): Promise<IContest> {
    const url = `api/contest/${contestSlug}`

    const response = await fetch(url)
    const contest = (await response.json()) as IContest

    return contest
  }

  public async submitOrder(
    order: IOrder,
    creditCardToken: string
  ): Promise<number> {
    const url = 'api/order'

    order.creditCardToken = creditCardToken

    const response = await fetch(url, {
      method: 'post',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(order)
    })

    if (!response.ok) {
      let message = 'There was an error submitting the order'

      if (response.status === 400) {
        // modelstateerror or stripeexceptionfilter error
        const json = await response.json()

        const values = Object.keys(json).map(key => json[key])
        const messages = values.reduce((a, b) => a.concat(b))
        console.log(messages)
        message = messages[0]
      }

      throw new Error(message)
    }

    const orderNumber = await response.json()
    return orderNumber
  }
}



// WEBPACK FOOTER //
// ./src/services/api.ts